import { message } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { getPaymentMethods } from '../../../services/general';
import { updatePayment } from '../../../services/reservation';

const usePaymentMethods = () => {
  const [paymentData, setData] = useState([]);
  const [paymentsLoading, setIsLoading] = useState(false);
  const [company, setCompany] = useState();

  const doFetch = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await getPaymentMethods(
        company ? { company_id: company } : {}
      );
      setData(response);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }, [company]);

  useEffect(() => {
    if (company) doFetch();
  }, [company, doFetch]);

  const doUpdate = async (params) => {
    setIsLoading(true);
    try {
      await updatePayment(params);
      message.success({
        content: "Método de pago actualizado exitosamente",
        style: {
          marginTop: "35vh",
          fontSize: 16,
        },
      });
    } catch (error) {
      console.log(error);
      message.error({
        content: `Error al actualizar el método de pago`,
        style: {
          marginTop: "35vh",
          fontSize: 16,
        },
      });
    } finally {
      setIsLoading(false);
    }
  }

  return { paymentData, paymentsLoading, doFetch, doUpdate, setCompany };
};

export default usePaymentMethods;